import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgLucideHand = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <g
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    >
      <path d="M18 11V6a2 2 0 0 0-2-2 2 2 0 0 0-2 2m0 4V4a2 2 0 0 0-2-2 2 2 0 0 0-2 2v2m0 4.5V6a2 2 0 0 0-2-2 2 2 0 0 0-2 2v8" />
      <path d="M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15" />
    </g>
  </svg>
);
const ForwardRef = forwardRef(SvgLucideHand);
const Memo = memo(ForwardRef);
export default Memo;
